import { render, staticRenderFns } from "./ThemeInfo.vue?vue&type=template&id=f3c95f72"
import script from "./ThemeInfo.vue?vue&type=script&lang=js"
export * from "./ThemeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports